import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import UpdatesFrequencyFields from "./components/UpdatesFrequencyFields.js";

const UpdatesFrequencyCard = () => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Field name="updatesFrequency" component={UpdatesFrequencyFields} />
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default UpdatesFrequencyCard;
